import moment from "moment";
export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor(Math.random() * arr.length)
  return arr[index]
}

export function formateDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}
// 左边补0函数
function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

export function handleScrollHeader(callback) {
  let timer = 0

  let beforeScrollTop = window.pageYOffset
  callback = callback || function () { }
  window.addEventListener(
    'scroll',
    event => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        let direction = 'up'
        const afterScrollTop = window.pageYOffset
        const delta = afterScrollTop - beforeScrollTop
        if (delta === 0) {
          return false
        }
        direction = delta > 0 ? 'down' : 'up'
        callback(direction)
        beforeScrollTop = afterScrollTop
      }, 50)
    },
    false
  )
}

export function isIE() {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.body.removeChild(document.getElementById(id))
  }, timeout)
}

/**
 * 邮箱
 * @param {*} s
 */
export function isEmail(s) {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile(s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone(s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL(s) {
  return /^http[s]?:\/\/.*/.test(s)
}

export function getUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
  })
}

/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export function filterObj(obj) {
  if (!(typeof obj == 'object')) {
    return;
  }

  for (let key in obj) {
    if (obj.hasOwnProperty(key) &&
      (obj[key] == null || obj[key] == undefined || obj[key] === '')) {
      delete obj[key];
    }
  }
  return obj;
}

//路由菜单排序
export function sortChildren(arr) {
  return arr.sort((a, b) => {
    return a.sortNo - b.sortNo
  })
}


// 生成首页路由
export function generateIndexRouter(data) {
  const r = generateChildRouters(data)
  let indexRouter = [
    {
      path: '/',
      meta: {
        title: '一站式人员入场服务平台'
      },
      redirect: `/${r[0].path}`,
      component: () => import('@/layout/content.vue'),
      children: [
        ...r
      ]
    },
  ]
  return indexRouter;
}

// 生成嵌套路由（子路由）

function generateChildRouters(data) {
  let routers = [];
  for (let item of data) {
    if (item.type == 2) {
      continue;
    }
    if (!item.component && item.children.length > 0) {
      routers = routers.concat(generateChildRouters(item.children))
      continue;
    }
    let componentPath;
    if (process.env.NODE_ENV === 'development') {
      componentPath = resolve => require(['@/' + item.component + '.vue'], resolve)
    } else {
      // 使用 import 实现生产环境的路由懒加载
      componentPath = () => import('@/' + item.component + '.vue')
    }
    let menu = {
      path: item.path || '',
      name: item.name || '',
      component: componentPath,
      hidden: item.hidden == 1 ? true : false,
      meta: {
        title: item.title,
        icon: !!item.icon ? item.icon : '',
        permissionList: item.children.filter(per => per.type == 2).map(permap => permap.power),
        keepAlive: item.keepalive == 1 ? true : false,
      }
    }
    menu.children = [...generateChildRouters(item.children)];
    // console.log(JSON.parse(JSON.stringify(menu)));
    if (item.alwaysShow) {
      menu.alwaysShow = true;
    }
    routers.push(menu);
  }
  return routers
}


/**
 * 是否是日期或日期时间格式
 */
export function isDateOrDateTime(str) {
  // 日期时间格式：yyyy-mm-dd hh:mm:ss
  var dateTimePattern = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

  // 日期格式：yyyy-mm-dd
  var datePattern = /^\d{4}-\d{2}-\d{2}$/;

  if (dateTimePattern.test(str) || datePattern.test(str)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 19981010格式数据转为YYYY-MM-DD格式
 */
export function sixformatDate(dateString) {
  // 提取年、月、日
  const year = dateString.slice(0, 4);
  const month = dateString.slice(4, 6);
  const day = dateString.slice(6, 8);

  // 构建新的日期字符串
  const formattedDate = `${year}-${month}-${day}`;

  return formattedDate;
}


/**
 * 读取表格中的日期格式时是数字，将数字转为日期格式
 */
export function excelTimeFormat(timeNum, format) {
  const d = timeNum - 1;
  const t = Math.round((d - Math.floor(d)) * 24 * 60 * 60);
  return moment(new Date(1900, 0, d, 0, 0, t)).format(
    format
  );
}

/**
 * 传入YYYY-MM-DD的格式，返回当前年龄
 * 不是有效格式返回0
 */
export function calculateAge(birthday) {
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

  if (!dateRegex.test(birthday)) {
    return 0;
  }

  const birthDate = new Date(birthday);
  const currentDate = new Date();

  let age = currentDate.getFullYear() - birthDate.getFullYear();

  if (
    currentDate.getMonth() < birthDate.getMonth() ||
    (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

//是否是视频格式文件
export function isVideoFileType(fileName) {
  const videoExtensions = [".mp4", ".mov", ".avi", ".mkv", ".wmv", ".flv"];

  const fileExtension = fileName
    .toLowerCase()
    .substring(fileName.lastIndexOf("."));

  return videoExtensions.includes(fileExtension);
}

//  秒数转化为时分秒
export function formatSeconds(value) {
  //  秒
  let second = parseInt(value)
  //  分
  let minute = 0
  //  小时
  let hour = 0
  //  天
  //  let day = 0
  //  如果秒数大于60，将秒数转换成整数
  if (second > 60) {
    //  获取分钟，除以60取整数，得到整数分钟
    minute = parseInt(second / 60)
    //  获取秒数，秒数取佘，得到整数秒数
    second = parseInt(second % 60)
    //  如果分钟大于60，将分钟转换成小时
    if (minute > 60) {
      //  获取小时，获取分钟除以60，得到整数小时
      hour = parseInt(minute / 60)
      //  获取小时后取佘的分，获取分钟除以60取佘的分
      minute = parseInt(minute % 60)
      //  如果小时大于24，将小时转换成天
      //  if (hour > 23) {
      //    //  获取天数，获取小时除以24，得到整天数
      //    day = parseInt(hour / 24)
      //    //  获取天数后取余的小时，获取小时除以24取余的小时
      //    hour = parseInt(hour % 24)
      //  }
    }
  }

  let result = '' + parseInt(second) + '秒'
  if (minute > 0) {
    result = '' + parseInt(minute) + '分' + result
  }
  if (hour > 0) {
    result = '' + parseInt(hour) + '小时' + result
  }
  //  if (day > 0) {
  //    result = '' + parseInt(day) + '天' + result
  //  }
  return result
}

export function docxContent(record, docx, result) {
  let pObj = docx.createP();
  pObj.options.align = "center";
  pObj.addText(`${record.person_name}的试卷`, {
    font_size: 24,
  });
  pObj = docx.createP();
  pObj.addText(`培训方案名称：${record.train_name}`, {
    font_size: 10,
  });
  pObj = docx.createP();
  pObj.addText(`分包单位：${record.company_name}`, {
    font_size: 10,
  });
  pObj = docx.createP();

  const adc = ["A", "B", "C", "D", "E", "F"];
  console.log("result", result);
  for (let i = 0; i < result.length; i++) {
    const v = result[i];
    console.log(v, "v");
    const qss = [v.q1, v.q2, v.q3, v.q4, v.q5, v.q6];
    //题型
    pObj = docx.createP();
    //题目
    pObj.addText(
      `${i + 1}.【${v.type == 1 ? "单选题" : v.type == 2 ? "判断题" : "多选题"
      }】 ${v.question}`,
      { font_size: 16, bold: true }
    );
    pObj = docx.createP();
    //选项
    for (let k = 0; k < qss.length; k++) {
      if (!!qss[k]) {
        pObj.addText(adc[k] + "、" + qss[k], { font_size: 16 });
        pObj = docx.createP();
      }
    }
    //答案
    pObj.addText("正确答案：" + v.answer, {
      font_size: 14,
      bold: true,
      color: "#FF0000",
    });
    pObj.addText("     ");
    pObj.addText("考生答案:" + (v.myanswer ? v.myanswer : "未作答"), {
      font_size: 14,
      bold: true,
      color: "#FF0000",
    });
    pObj = docx.createP();
    pObj.addText(
      `${v.answer === v.myanswer
        ? "回答正确" + "+" + v.fenzhi + "分"
        : "回答错误"
      }`,
      {
        font_size: 10,
        bold: true,
        color: v.answer === v.myanswer ? "#008000" : "#FF0000",
      }
    );
    pObj = docx.createP();
  }
  pObj.addText(`----------------------------`);
  pObj = docx.createP();

  pObj.addText(`合计： ${result.length} 题  得分：${record.score}`, {
    font_size: 14,
    bold: true,
  });
  pObj = docx.createP();
  //结果颜色
  // const overcolor =
  //   record.pass_type == 1
  //     ? "#FF0000"
  //     : record.pass_type == 2
  //       ? "#FFA500"
  //       : "#008000";
  // pObj.addText(
  //   "综合判定:" +
  //   (record.pass_type == 1
  //     ? "不合格"
  //     : record.pass_type == 2
  //       ? "合格"
  //       : record.pass_type == 3
  //         ? "优秀"
  //         : ""),
  //   {
  //     font_size: 14,
  //     bold: true,
  //     color: overcolor,
  //   }
  // );
  // pObj = docx.createP();
  // pObj.addText(
  //   `判断标准：及格线${record.bad}分、 及格${record.bad}分~${record.good}分、优秀分数线>=${record.good}分`,
  //   {
  //     font_size: 12,
  //     bold: true,
  //   }
  // );

  return pObj
}